import { api, tokenStore } from './client';
import type { LoginResponse, User } from '@/types';

export const authApi = {
  async login(email: string, password: string, otpCode?: string): Promise<LoginResponse> {
    const payload: Record<string, string> = { email, password };
    if (otpCode) payload.otp_code = otpCode;
    const { data } = await api.post<LoginResponse>('/auth/login/', payload);
    tokenStore.set(data.access, data.refresh);
    if (data.user.companies.length > 0) tokenStore.setCompanyId(data.user.companies[0].company_id);
    return data;
  },
  async register(payload: {
    code: string; email: string; password: string;
    first_name: string; last_name: string; patronymic?: string; phone?: string;
  }): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/auth/register/', payload);
    tokenStore.set(data.access, data.refresh);
    if (data.user.companies.length > 0) tokenStore.setCompanyId(data.user.companies[0].company_id);
    return data;
  },
  async me(): Promise<User> {
    const { data } = await api.get<User>('/auth/me/');
    return data;
  },
  async updateMe(payload: Partial<User>): Promise<User> {
    const { data } = await api.patch<User>('/auth/me/', payload);
    return data;
  },
  async changePassword(oldPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password/', { old_password: oldPassword, new_password: newPassword });
  },
  async logout(): Promise<void> {
    const refresh = tokenStore.getRefresh();
    try { if (refresh) await api.post('/auth/logout/', { refresh }); }
    finally { tokenStore.clear(); }
  },
  async enable2FA(): Promise<{ secret: string; qr_code: string }> {
    const { data } = await api.post('/auth/2fa/enable/');
    return data;
  },
  async confirm2FA(code: string): Promise<void> {
    await api.post('/auth/2fa/confirm/', { code });
  },
};
